export default __webpack_public_path__ + "static/media/minusButton.f4e2077c.svg";